var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectInput',_vm._b({attrs:{"items":_vm.followUpOptions},on:{"input":_vm.change},model:{value:(_vm.future),callback:function ($$v) {_vm.future=$$v},expression:"future"}},'SelectInput',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }